import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { httpClient } from '../../services/http.client';
import { queryKeys } from '../../lib/query-keys';

export interface InAppNotification {
  id: string;
  user_id: string;
  title: string;
  message: string;
  notification_type: string;
  action_url: string | null;
  is_read: boolean;
  notification_status: string;
  created_at: string;
}

async function fetchInbox(): Promise<InAppNotification[]> {
  const res = await httpClient.get<any>('/api/v1/notifications/user-notifications?size=50');
  const data = (res as any).data;
  const items: any[] = Array.isArray(data)
    ? data
    : (data?.notifications ?? data?.data ?? []);
  return items.sort(
    (a: any, b: any) =>
      new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
  );
}

export function useNotifications(userId: string | null) {
  return useQuery({
    queryKey: queryKeys.notifications.inbox(userId ?? ''),
    queryFn: fetchInbox,
    enabled: !!userId,
    refetchInterval: 30_000,  // poll every 30 s for new notifications
    staleTime: 10_000,
  });
}

export function useMarkNotificationRead() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) =>
      httpClient.post(`/api/v1/notifications/user-notifications/${id}/mark-read`, {}),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['notifications'] });
    },
  });
}

export function useMarkAllRead() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () =>
      httpClient.post('/api/v1/notifications/user-notifications/mark-all-read', {}),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['notifications'] });
    },
  });
}
